const stopLabelFromIndex = (idx) =>
	idx < 0 ? 'Start' : `Checkpoint ${String.fromCharCode(65 + idx)}`;

export default stopLabelFromIndex;
